import * as React from 'react';
import * as firebase from 'firebase/app';
import { connect, Dispatch } from 'react-redux';
import { replace as replaceAction } from 'react-router-redux';
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import { withGoogleyolo, Login, Credential, ErrorType } from 'react-googleyolo';
import { Button } from 'antd';

import { AppState, UserInfo, AuthState } from 'src/store';
import { gauthAsync } from 'src/api';
import { actions as toastActions, Toast } from 'src/toast';
import { RouteComponentProps } from 'react-router';
import { actions } from '../redux';
import bg from './bg.jpg';
import k from './app-logo.png';
import { Unsubscribe } from 'firebase/app';

const locationHelper = locationHelperBuilder({});

const mapStateToProps = ({ authState }: AppState, ownProps: RouteComponentProps<{}>) => {
  const redirect = locationHelper.getRedirectQueryParam(ownProps) || '/';

  return {
    authState,
    redirect
  };
};
const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    replace: (route: string) => {
      dispatch(replaceAction(route));
    },
    loggingIn: () => {
      dispatch(actions.loggingIn());
    },
    loggedIn: (userInfo: UserInfo) => {
      dispatch(actions.loggedIn(userInfo));
    },
    error: (content: React.ReactNode) => {
      dispatch(toastActions.error(content));
    }
  };
};

const clientId = process.env.REACT_APP_GOOGLE_CREDENTIALS_CLIENT_ID;

interface Props extends RouteComponentProps<{}> {
  authState: AuthState;
  redirect: string;
  // tslint:disable-next-line:no-any
  googleyolo: any;
  replace: (route: string) => void;
  loggingIn: () => void;
  loggedIn: (userInfo: UserInfo) => void;
  error: (content: React.ReactNode) => void;
}

class SignIn extends React.Component<Props, {}> {
  unsub: Unsubscribe;

  componentDidMount() {
    const { loggedIn, replace, redirect } = this.props;
    this.unsub = firebase.auth().onAuthStateChanged(async uinfo => {
      if (uinfo) {
        const token = await uinfo.getIdToken();
        loggedIn({ userId: uinfo.uid, token });
        replace(redirect);
      }
    });
  }

  componentWillUnmount() {
    if (this.unsub) {
      this.unsub();
    }
  }

  handleGoogleLoginSuccess = async (credential: Credential) => {
    const { loggingIn, loggedIn, error, replace, redirect } = this.props;
    loggingIn();
    const r = await gauthAsync(credential.idToken);
    if (!r.success) {
      error(
        <React.Fragment>
          <span>Login with </span>
          <strong>datafocus.cloud</strong>
          <span> account <a href="https://accounts.google.com">here</a></span>
        </React.Fragment>
      );
    } else if (r.token && r.userId) {
      const fsResult = await firebase.auth().signInWithCustomToken(r.token);
      // tslint:disable-next-line:no-console
      console.log('firebase result: ', fsResult);
      loggedIn({ userId: r.userId, token: r.token });
      replace(redirect);
    }
  }

  handleGoogleLoginError = ({ type }: { type: ErrorType }) => {
    // tslint:disable-next-line:no-console
    console.log('error type: ', type);
    const { error } = this.props;
    switch (type) {
      case 'noCredentialsAvailable':
        error(
          <React.Fragment>
            <span>Login with </span>
            <strong>datafocus.cloud</strong>
            <span> account <a href="https://accounts.google.com">here</a></span>
          </React.Fragment>
        );
        break;
      default:
        return;
    }
  }

  renderLoginNode = (props: { children?: React.ReactNode }) => {
    const { authState } = this.props;
    return (
      <Button
        loading={authState.status === 'loading'}
        type="primary"
        icon="login"
        {...props}
      >
        Sign In
      </Button>);
  }

  render() {
    return (
      <div className="App">
        <Toast />
        <div className="login" style={{ backgroundImage: `url(${bg})` }}>
          <div className="box">
            <img src={k} />
            <Login
              node={this.renderLoginNode}
              clientId={clientId}
              supportedAuthMethods={[
                'https://accounts.google.com',
              ]}
              onLoginSuccess={this.handleGoogleLoginSuccess}
              onLoginError={this.handleGoogleLoginError}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withGoogleyolo(connect(mapStateToProps, mapDispatchToProps)(SignIn));



// WEBPACK FOOTER //
// ./src/auth/containers/Login.tsx